import React from "react";
import { Instagram, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export default function Footer() {
  const { t } = useApp();
  return (
    <footer className="border-t border-foreground mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 grid grid-cols-2 md:grid-cols-[1.6fr_1fr_1fr_1fr] gap-x-6 gap-y-7">
        <div className="col-span-2 md:col-span-1" data-testid="footer-brand">
          <img src="/brand/soul-radar-full.png" alt="Soul Radar – Your Soul Event Finder" className="h-[36px] w-auto dark:[filter:invert(1)_hue-rotate(180deg)]" data-testid="footer-logo" />
          <p className="mt-3 text-sm text-muted-foreground max-w-sm" data-testid="footer-statement">{t("footerNote")}</p>
          <div className="mt-3 flex items-center gap-2 text-sm" data-testid="footer-social">
            <a href="https://www.instagram.com/soulradar.events/" target="_blank" rel="noreferrer noopener" className="inline-flex items-center gap-1.5 hover:text-primary transition-colors" data-testid="social-instagram"><Instagram className="w-4 h-4" />Instagram</a>
            <span aria-hidden="true" className="text-muted-foreground">·</span>
            <a href="https://www.facebook.com/soulradar.events/" target="_blank" rel="noreferrer noopener" className="inline-flex items-center gap-1.5 hover:text-primary transition-colors" data-testid="social-facebook"><Facebook className="w-4 h-4" />Facebook</a>
          </div>
        </div>
        <nav className="flex flex-col gap-2 text-sm" aria-label="Explore" data-testid="footer-explore">
          <span className="eyebrow">{t("footerExplore")}</span>
          <Link to="/" className="hover:text-primary transition-colors py-0.5">{t("home")}</Link>
          <Link to="/archive" className="hover:text-primary transition-colors py-0.5" data-testid="footer-archive">{t("archive")}</Link>
          <Link to="/about" className="hover:text-primary transition-colors py-0.5" data-testid="footer-about">{t("about")}</Link>
        </nav>
        <nav className="flex flex-col gap-2 text-sm" aria-label="Support" data-testid="footer-support">
          <span className="eyebrow">{t("footerSupport")}</span>
          <Link to="/faq" className="hover:text-primary transition-colors py-0.5" data-testid="footer-faq">FAQ</Link>
          <Link to="/help" className="hover:text-primary transition-colors py-0.5" data-testid="footer-help">{t("supportContact")}</Link>
          <Link to="/guidelines" className="hover:text-primary transition-colors py-0.5" data-testid="footer-guidelines">{t("guidelines")}</Link>
        </nav>
        <nav className="flex flex-col gap-2 text-sm" aria-label="Legal" data-testid="footer-legal">
          <span className="eyebrow">LEGAL</span>
          <Link to="/privacy" className="hover:text-primary transition-colors py-0.5">{t("privacy")}</Link>
          <Link to="/imprint" className="hover:text-primary transition-colors py-0.5">{t("imprint")}</Link>
          <Link to="/terms" className="hover:text-primary transition-colors py-0.5" data-testid="footer-terms">{t("terms")}</Link>
        </nav>
      </div>
      <div className="border-t border-foreground text-xs px-4 md:px-6 py-4 uppercase font-display tracking-wider">
        © {new Date().getFullYear()} Soul Radar
      </div>
    </footer>
  );
}
